import styled from "styled-components";

import { MainContainer } from "@/components/Layout/Styled";

export const StyledBottomSheetTop = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 20px;
    margin-bottom: 8px;
    align-items: center;
`;

export const StyledMainContainer = styled(MainContainer)`
    padding: 0;
`;
